import { withCookieFirstRequest } from '../../shared/api/cookieAuthRequest'
import type {
  CustomerMePayload,
  CustomerProfileUpdateInput,
} from '../types'
import { requestCustomerAuthJson } from './core'

export const fetchCustomerMe = (token?: string | null) =>
  requestCustomerAuthJson<CustomerMePayload>('/auth/customer/me', {
    ...withCookieFirstRequest({
      init: {
        method: 'GET',
      },
      bearerFallbackToken: token,
    }),
  })

export const updateCustomerProfile = (
  input: CustomerProfileUpdateInput,
  token?: string | null,
) =>
  requestCustomerAuthJson<CustomerMePayload>('/account/profile', {
    ...withCookieFirstRequest({
      init: {
        method: 'PATCH',
        body: JSON.stringify(input),
      },
      bearerFallbackToken: token,
    }),
  })

export const logoutCustomer = (token?: string | null) =>
  requestCustomerAuthJson<{ revoked: boolean }>('/auth/customer/logout', {
    ...withCookieFirstRequest({
      init: {
        method: 'POST',
        body: JSON.stringify({}),
      },
      bearerFallbackToken: token,
    }),
  })
